/**
 * Converts number strings into numbers
 * @param {Any} value Form field value
 */
export const initialValueConverter = (value: any) => {
  if (!value) return undefined
  if (Array.isArray(value)) return value
  if (typeof value !== 'string') return value

  // Only convert query params that are strictly digits.
  // This avoids breaking values like "+919..." (phone), UUID-ish strings, etc.
  if (!/^\d+$/.test(value)) return value

  return parseInt(value, 10)
}
